<template>
  <v-app :class="selectedLang === 'ja' ? 'ja' : 'en'">
    <v-app-bar
      app
      v-if="isShowAppBar"
    >
      <v-toolbar-title class="headline py-0">
        <v-img
          :src="require('./assets/images/logo.png')"
          contain
          position="left center"
          height="40"
          @click="toTop"
        ></v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        v-if="!$route.path.startsWith('/app/')"
        class="mr-2 px-2"
        color="primary"
        outlined
        style="text-transform:none !important;border-radius:8px;height:32px;font-weight:bold"
        @click="$router.replace('/signInTemp')"
      >Log In
      </v-btn>
      <div class="v-app-bar-border">
        <v-menu offset-y v-if="$route.name === 'Top' || $route.name === 'enTop'">
          <template v-slot:activator="{ on }">
            <v-btn
              color="textBlack"
              text
              large
              class="font-weight-bold"
              v-on="on"
            >
              {{ selectedLang === 'en' ? 'ja' : 'en' }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(lang, index) in list"
              :key="index"
              @click="changeLang(lang)"
            >
              <v-list-item-title>{{ lang.toUpperCase() }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>

    <v-footer
      dark
      padless
      :class="isSPSize ? 'sp' : ''"
      v-if="isShowFooter"
    >
       <v-card
        class="flex"
        flat
        tile
        :max-width="isSPSize ? '' : '1220px'"
      >
        <v-card-title>
          <v-layout
            wrap
            row
          >
            <v-flex xs12 sm3 class="mx-3">
              <v-img
                style="cursor: pointer"
                :src="require('./assets/images/logo.png')"
                contain
                position="left"
                :class="isSPSize ? 'd-inline-flex' : 'd-block'"
                :height="isSPSize ? 53 : 80"
                :width="isSPSize ? 100 : 150"
                @click="toTop"
              ></v-img>
              <v-btn
                class="ma-0"
                color="textGray"
                icon
                @click="goToFacebook">
                <v-icon>mdi-facebook-box</v-icon>
              </v-btn>
              <v-btn
                class="ma-0"
                color="textGray"
                icon
                @click="goToInstagram">
                <v-icon>mdi-instagram</v-icon>
              </v-btn>
              <v-btn
                class="ma-0"
                color="textGray"
                icon
                @click="goToTwitter">
                <v-icon>mdi-twitter</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12 sm6 offset-sm3>
                <v-btn
                  text x-small
                  color="gray"
                  class="text-capitalize"
                  @click="$router.push(`/${selectedLang}/faq`)"
                >&#x1f64b;FAQ</v-btn>
                <v-btn
                  text x-small
                  color="gray"
                  class="text-capitalize"
                  @click="$router.push(`/${selectedLang}/aboutUs`)"
                >&#x1f44b;About Us</v-btn>
                <v-btn
                  text x-small
                  color="gray"
                  class="text-capitalize"
                  @click="goTo('mailto:support@paikeout.com')"
                >&#x1f4e9;Contact</v-btn>
                <v-btn
                  text x-small
                  color="gray"
                  style="text-transform:none !important"
                  @click="$router.push(`/${selectedLang}/tos`)"
                >&#x1f4d6;Terms of Service</v-btn>
                <v-btn
                  text x-small
                  color="gray"
                  class="text-capitalize"
                  @click="$router.push(`/${selectedLang}/privacy`)"
                >&#x1f4d9;Privacy Policy</v-btn>
                <v-btn
                  text x-small
                  color="gray"
                  class="text-capitalize"
                  @click="goTo('https://paikeout.com/blog/ja/')"
                >&#x1f4f1;Blog(日本語)</v-btn>
                <v-btn
                  text x-small
                  color="gray"
                  class="text-capitalize"
                  @click="goTo('https://paikeout.com/blog/en/')"
                >&#x1f4f1;Blog(EN)</v-btn>
            </v-flex>
          </v-layout>

        </v-card-title>
        <v-card-text
          class="textGray--text"
          :class="isSPSize ? 'text-center' : 'text-right'">
          © Attic Start Inc. All Rights Reserved.
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import firebase from 'firebase/app'
import "firebase/firestore"
import firebaseConfig from '@/firebase/firebase';
import { mapState, mapActions } from 'vuex'

export default {
  name: 'App',
  data: () => ({
    //
  }),
  computed: {
    ...mapState('lang', [
      'selectedLang',
      'list'
    ]),
    isSPSize() {
      return this.$vuetify.breakpoint.name === 'xs'
    },
    /** AppBarの出力条件 */
    isShowAppBar() {
      return this.$route.path === '/'
        || this.$route.path === '/en'
        || this.$route.path.startsWith('/ja/')
        || this.$route.path.startsWith('/en/')
        || this.$route.path.startsWith('/app/tos')
        || this.$route.path.startsWith('/app/privacy')
    },
    /** Footerの出力条件 */
    isShowFooter() {
      return this.$route.name !== 'OnBoarding'
        && this.$route.name !== 'RNActivity'
        && this.$route.name !== 'AppTos'
        && this.$route.name !== 'AppPrivacy'
        && !window.ReactNativeWebView
    }
  },
  created() {
    firebase.initializeApp(firebaseConfig);
  },
  mounted() {
    /**
     * ブラウザの言語設定を見に行く
     */
    let language = (window.navigator.languages && window.navigator.languages[0]) ||
      window.navigator.language ||
      window.navigator.userLanguage ||
      window.navigator.browserLanguage
    if (!language) {
      language = 'en'
    } else {
      language = language.substring(0, 2)
    }
    this.setLang(language)
    if (this.selectedLang.includes('ja') && this.$route.name === 'enTop') {
      this.$router.push('/')
    } else if (!this.selectedLang.includes('ja') && this.$route.name === 'Top') {
      this.$router.push('/en')
    }
  },
  methods: {
    ...mapActions('lang', [
      'setLang'
    ]),
    toTop() {
      if (this.selectedLang === 'en') {
        this.$router.push('/en')
      } else {
        this.$router.push('/')
      }
    },
    changeLang(val) {
      this.setLang(val)
      if (this.selectedLang === 'en') {
        this.$router.push(`/${this.selectedLang}/`)
      } else {
        this.$router.push('/')
      }
    },
    goTo(url) {
      window.open(url)
    },
    goToFacebook() {
      window.open('https://www.facebook.com/paikeout/', '_blank')
    },
    goToInstagram() {
      window.open('https://www.instagram.com/paikeout/', '_blank')
    },
    goToTwitter() {
      window.open('https://twitter.com/paikeout', '_blank')
    },
  },
};
</script>

<style lang="stylus">
html, body
  .v-application
    background white !important
    font-family Nunito, 'SF Compact Rounded', -apple-system, BlinkMacSystemFont, 'Noto Sans JP', sans-serif
* :not(.v-icon)
  font-family Nunito, 'SF Compact Rounded', -apple-system, BlinkMacSystemFont, 'Noto Sans JP', sans-serif
</style>

<style lang="stylus" scoped>
/deep/ .v-toolbar__content
  padding-top 0
  padding-bottom 0
  padding-right 0
  .v-app-bar-border
    border-left 1px solid #ddd
    height 100%
    .v-btn
      height 100%
/deep/ .container
  max-width 1220px !important
  padding 0
  margin 80px auto
  &.sp
    max-width unset
    width 90.6%
    margin 43px 4.7%
.v-footer
  background-color #f5f5f5 !important

  .v-card
    margin 10px 0 70px

  .footer-logo
    cursor pointer

  .theme--dark.v-sheet
    background-color transparent !important

  ul
    li
      list-style none
      padding 0
      font-size 18px
      margin-left 47px
      p, a
        font-size 13px
        background-image url('./assets/images/arrow-link.svg')
        background-size 6px
        padding-left 16px
        text-decoration none
        vertical-align middle
        background-position 0 center
        margin-bottom 0
        cursor pointer

  p
    padding-left 20px

  &.sp
    ul
      margin-bottom 30px
      li
        margin-left 0
        margin-right 20px

</style>